import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../App.css';

const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_ORIGIN;

const FeedPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    async function getGames() {
      try {
        const res = await fetch(`${BACKEND_ORIGIN}/games`);
        if (!res.ok) {
          throw new Error(`Fetch error (not ok): ${res.status}`)
        }
        const jsonData= await res.json();
        setData(jsonData);
        console.log("Live updated!");
      }
      catch(err) {
        throw new Error(`Fetch error (what): ${err}`);
      }
      finally {
        setLoading(false);
      }
    }
    getGames();
    const interval = setInterval(getGames, 1000 * 60);
    return () => clearInterval(interval);
  }, []);
  if (loading) {
    return (
      <div>
        Loading...
      </div>
    );
  }
  const handleGameNav = (gameID) => {
    navigate(`game/${gameID}`);
  }
  const liveScores = [];
  const todaySchedule = [];
  const todayFinal = [];
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const games = data["games"];
  /*const teamname = games[0]["game"]["home"]["names"]["seo"];
  const logo = fetch("http://localhost:8080/logo", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({teamname})
  });
  console.log(logo);*/
  //console.log(games);
  for (let i = 0; i < games.length; i++) {
    const gameDate = games[i]["game"]["startDate"].split("/").map(Number);
    const gameDateObj = new Date(gameDate[2], gameDate[0] - 1, gameDate[1]);
    // REPLACE new Date WITH today
    if (gameDateObj.getTime() < today.getTime()) {
      continue;
    }
    if (gameDateObj.getTime() > today.getTime()) {
      break;
    }
    if (games[i]["game"]["gameState"] == "pre") {
      todaySchedule.push(
        <div className="score-card" key={i} onClick={() => {handleGameNav(games[i]["game"]["gameID"])}}>
          <div className="score-card-header">
            <div className="sport-tag">NCAA College Football</div>
            <div className="sport-tag">{games[i]["game"]["startTime"]}</div>
          </div>
          <div className="score-row">
            <div className="team-block">
              <div
                className="team-logo"
                style={{
                  background: 'rgba(0,45,114,0.2)',
                  color: '#002d72',
                  border: '1.5px solid rgba(0,45,114,0.3)'
                }}
              >
                {games[i]["game"]["away"]["names"]["char6"]}
              </div>
              <div>
                <div className="team-name">{games[i]["game"]["away"]["names"]["short"]}</div>
                <div className="team-record">0-0</div>
              </div>
            </div>
            <div className="score-center">
              <div style={{
                fontFamily: 'var(--font-head)',
                fontSize: '18px',
                fontWeight: '800',
                color: 'var(--fd-muted)'
              }}>
                vs
              </div>
              <div className="score-period">Tonight</div>
            </div>
            <div className="team-block right">
              <div
                className="team-logo"
                style={{
                  background: 'rgba(12,35,64,0.2)',
                  color: '#0c2340',
                  border: '1.5px solid rgba(12,35,64,0.3)'
                }}
              >
                {games[i]["game"]["home"]["names"]["char6"]}
              </div>
              <div>
                <div className="team-name">{games[i]["game"]["home"]["names"]["short"]}</div>
                <div className="team-record">0-0</div>
              </div>
            </div>
          </div>
          <div className="score-card-footer">
          </div>
        </div>
      );
    }
    else if (games[i]["game"]["gameState"] != "final") {
      liveScores.push(
        <div className="score-card live" key={i} onClick={() => {handleGameNav(games[i]["game"]["gameID"])}}>
          <div className="score-card-header">
            <div className="sport-tag">
              NCAA College Football
            </div>
          </div>
          <div className="score-row">
            <div className="team-block">
              <div className="team-logo" style={{
                  background: 'rgba(29,77,120,0.25)',
                  color: '#1d4d78',
                  border: '1.5px solid rgba(29,77,120,0.4)'
                }}>
                {games[i]["game"]["away"]["names"]["char6"]}
              </div>
              <div>
                <div className="team-name">
                  {games[i]["game"]["away"]["names"]["short"]}
                </div>
              </div>
            </div>
            <div className="score-center">
              <div className="score-nums">{games[i]["game"]["away"]["score"]} - {games[i]["game"]["home"]["score"]}</div>
              <div className="score-period">{games[i]["game"]["currentPeriod"]} {games[i]["game"]["contestClock"]}</div>
            </div>
            <div className="team-block right">
              <div className="team-logo" style={{
                  background: 'rgba(149,71,12,0.2)',
                  color: '#95470c',
                  border: '1.5px solid rgba(149,71,12,0.35)'
                }}>
                {games[i]["game"]["home"]["names"]["char6"]}
              </div>
              <div>
                <div className="team-name">
                  {games[i]["game"]["home"]["names"]["short"]}
                </div>
              </div>
            </div>
          </div>
          <div className="score-card-footer">
            <div className="betting-line"></div>
          </div>
        </div>
      );
    }
    else {
      todayFinal.push(
        <div className="score-card live" key={i} onClick={() => {handleGameNav(games[i]["game"]["gameID"])}}>
          <div className="score-card-header">
            <div className="sport-tag">
              NCAA College Football
            </div>
          </div>
          <div className="score-row">
            <div className="team-block">
              <div className="team-logo" style={{
                  background: 'rgba(29,77,120,0.25)',
                  color: '#1d4d78',
                  border: '1.5px solid rgba(29,77,120,0.4)'
                }}>
                {games[i]["game"]["away"]["names"]["char6"]}
              </div>
              <div>
                <div className="team-name">
                  {games[i]["game"]["away"]["names"]["short"]}
                </div>
              </div>
            </div>
            <div className="score-center">
              <div className="score-nums">{games[i]["game"]["away"]["score"]} - {games[i]["game"]["home"]["score"]}</div>
              <div className="score-period">{games[i]["game"]["currentPeriod"]} {games[i]["game"]["contestClock"]}</div>
            </div>
            <div className="team-block right">
              <div className="team-logo" style={{
                  background: 'rgba(149,71,12,0.2)',
                  color: '#95470c',
                  border: '1.5px solid rgba(149,71,12,0.35)'
                }}>
                {games[i]["game"]["home"]["names"]["char6"]}
              </div>
              <div>
                <div className="team-name">
                  {games[i]["game"]["home"]["names"]["short"]}
                </div>
              </div>
            </div>
          </div>
          <div className="score-card-footer">
            <div className="betting-line"></div>
          </div>
        </div>

      );
    }
  }
  return (
    <div className="page active" id="feed">
      <div className="page-header">
        <h1 className="page-title">LIVE NOW</h1>
        <div className="live-indicator">
          <span>●</span>
          <span>LIVE</span>
        </div>
      </div>
      <div className="feed-content">
      <div className="section-title">🔴 Live Games</div>

      <div>
          {liveScores}
      </div>

      <div className="section-title" style={{ marginTop: '24px' }}>📅 Today's Schedule</div>
      <div>{todaySchedule}</div>
      {/* Scheduled Game Card */}

      <div className="section-title" style={{marginTop: "24px"}}>✅ Final - Scores</div>
      <div>{todayFinal}</div>

      <div className="section-title" style={{marginTop:'24px'}}>✅ Final — Top Reviews (UNDER CONSTRUCTION)</div>
  {/*
      <div className="review-card">
        <div className="review-header">
          <div className="msg-avatar verified" style={{background: 'linear-gradient(135deg, #2a6496, #1a3d5c)', width:'32px', height:'32px', fontSize:'12px'}}>SS</div>
          <div>
            <div style={{fontSize:'13px', fontWeight:'600'}}>SportsScribe <span className="fan-badge">Top Fan</span></div>
            <div style={{fontSize:'11px', color:'var(--fd-muted)'}}>Celtics 118 · Cavs 104 · Final</div>
          </div>
            <div className="stars">
            <span className="star">★</span><span className="star">★</span><span className="star">★</span><span className="star">★</span><span className="star empty">★</span>
          </div>
        </div>
        <div className="review-text">Tatum went absolutely nuclear in the 4th. This was a must-watch. Cavs had no answer for the small-ball lineup Boston threw out after halftime.</div>
          <div className="review-footer">
            <div className="foam-btn active"><span className="foam-icon">🤙</span> 847</div>
            <div className="visibility-badge public">Public</div>
          </div>
        </div>*/}
      </div>
    </div>
  );
};

export default FeedPage;
